import type { Control, FieldValues, Path } from 'react-hook-form'

import { InputFormField } from 'src/shared/components/ui/forms/form-fields/input'

interface AuthInputFormFieldProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label: string
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'currency' | 'date'
}

export default function AuthInputFormField<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  type,
}: AuthInputFormFieldProps<T>) {
  return (
    <InputFormField
      control={control}
      name={name}
      label={label}
      placeholder={placeholder}
      className="space-y-1"
      fieldClassName="text-primary border-none xs:text-[15px] translate-y-[7px] placeholder:translate-y-0 bg-transparent px-5"
      floatingLabelClassName="pointer-events-none bg-transparent -translate-y-[3px] px-4 peer-focus:px-4 peer-focus:-translate-y-[2px] peer-placeholder-shown:translate-y-[-42%]"
      fieldContainerClassName="bg-[#F8F7F5] rounded-[12px] h-[60px]"
      // errorClassName="mt-2 mb-2"
      type={type}
    />
  )
}
